import moment from 'moment'
import React, { Fragment } from 'react'
import { Convert24hrTo12hr } from 'utils/Convert24hrTo12hr'

export const getDriveMode = driveMode => {
  return driveMode?.toLowerCase().replace('_', ' ')
}

export const getDriveRoles = driveRoleMap => {
  const roles = driveRoleMap?.map(({ role }) => role?.tittle).join()
  return roles
}

export const getDriveDate = date => {
  let startDate = moment(date?.startDate)
  let endDate = moment(date?.endDate)
  let isOnlyStartDate = endDate.isValid()

  const getFormat = () => {
    return (
      <Fragment>
        {startDate.format('DD/MM/YYYY')}
        &nbsp; - &nbsp;
        {endDate.format('DD/MM/YYYY')}
      </Fragment>
    )
  }
  return startDate.isValid() ? (
    <span>
      {!isOnlyStartDate ? startDate.format('DD/MM/YYYY') : getFormat()}
    </span>
  ) : (
    ''
  )
}

export const getDriveTime = date => {
  let startTime = Convert24hrTo12hr(date?.startTime)
  let endTime = Convert24hrTo12hr(date?.endTime)

  let isOnlystartTime = !!date?.endTime
  let isOnlyEndTime = !!date?.startTime

  if (!isOnlystartTime && !isOnlyEndTime) {
    return '-'
  } else if (!isOnlystartTime) {
    return startTime
  } else if (!isOnlyEndTime) {
    return endTime
  } else {
    return (
      <div>
        {startTime} - {endTime}
      </div>
    )
  }
}
